export default {
    environment: 'local',
    api: {
        baseUrl: 'https://localhost:7177',
        courses: {
            apiEndpoint: '/api/courses',
        },
        profile: {
            apiEndpoint: '/api/Profile',
        },
        users: {
            sync: {
                apiEndpoint: '/api/user/sync',
            },
        },
    },
    firebase: {
        apiKey: 'AIzaSyABffI2eVTVBI1RYn0Y_ziv5RMTh7JKhm4',
        authDomain: 'academy-42ff5.firebaseapp.com',
        projectId: 'academy-42ff5',
        storageBucket: 'academy-42ff5.firebasestorage.app',
        messagingSenderId: '653215795008',
        appId: '1:653215795008:web:ebbdf7904a5949d9a4dca5',
        measurementId: 'G-PXKYCEPC0S',
    },
};

